import React, { createContext, useEffect,  useRef,  useState } from 'react'
import axios from "axios"
 export const AuthContext = createContext()
function AuthContextProvider({children}) {
  const [data, setData] = useState([])
  const [isAuth, setIsAuth] = useState(false)
  const usname = useRef(null)
  useEffect(() => {
    getData()
  }, [])
    function setUsername(name){
      usname.current = name
    }
    function getData(){
      axios.get("https://basic-api-list.herokuapp.com/users")
      .then(res =>{
        console.log(res.data)
        setData(res.data)
      } )
    }
    function signup(email,password,username){
      axios({
        url:"https://basic-api-list.herokuapp.com/users",
        method:"POST",
        data:{
          email:email,
          password:password,
          username:username
        }
      }).then(()=>getData())
    }
  return (
        <AuthContext.Provider value={{signup,isAuth,setIsAuth,setUsername,usname,data,getData}}>
            {children}
        </AuthContext.Provider>
  )
}

export default AuthContextProvider